module.exports = __webpack_public_path__ + "assets/img/ointment_icon.d8338214.svg";